const deleteCode = "DELETE";

export default deleteCode;